import React, { useEffect, useState } from "react";
import { SelectText } from "../index";
import { useFetch } from "../../../libs/api-hook";
import { isEmpty, map } from "lodash";

export const AsyncSelect = ({
  action,
  singleValue,
  dataLabel,
  dataValue,
  value,
  onChange,
  hasBlank,
  isLoading,
  dataSelector,
  ...props
}) => {
  const { data, loading } = useFetch({ action, variables: props });
  const [option, setOption] = useState();
  const formatOption = (list) =>
    map(list, (item) => {
      return singleValue
        ? { label: item, value: item }
        : {
            label: item[dataLabel],
            value: item[dataValue],
          };
    });

  const options = formatOption(data);
  if(hasBlank && options.length >= 1) options.unshift( { label: '', value: undefined })
  
  useEffect(() => {
    let optionValue;
    if (options.length === 0) return;
    
    if(!value) {
      setOption(null)
      onChange({})
      return;
    }
    const compValue = value instanceof Object? value.value: value;
    optionValue = options.find((option) => option.value === compValue) || "";
    if (options.length === 1) optionValue = options[0];
    if(option && option.value === optionValue.value) return;
    
    
    if (optionValue) {
      setOption(optionValue);
      onChange(optionValue);
    }
  }, [value, options.length]);

  useEffect(()=>{
    if (options.length === 1 && isEmpty(option)){
      setOption(options[0]);
      onChange(options[0]);
    }
  }, [options, option])
  return (
    <SelectText
      {...props}
      dataSelector={dataSelector}
      onChange={onChange}
      isLoading={isLoading || loading}
      options={options}
      value={option}
    />
  );
};

export default AsyncSelect;
